'use client';

import { useDebouncedCallback } from '@mantine/hooks';
import { RichEditorSimple } from '@/components/RichEditor/RichEditorSimple';

export function SimpleContentField({
  content,
  onChange,
}: {
  content: string;
  onChange: (content: string) => void;
}) {
  const debouncedOnChange = useDebouncedCallback(onChange, {
    delay: 500,
    flushOnUnmount: true,
  });

  return <RichEditorSimple initialContent={content} onChange={debouncedOnChange} />;
}
